import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SideBar from '../SquadChat/sideNav';
import TopNav from '../Utility/TopNav/topnav';
import { getProfile } from './Services/getProfile';
import { updateAccountType } from './Services/updateAccountType';
import { getUserThanksPoints } from './Services/getUserThanksPoints';
import { getUserReports } from './Services/getUserReports';
import { reducer, initialState } from './reducer'
import RootLoader from '../../Common/Loader/RootLoader';
import { Modal } from 'react-bootstrap';
import API from '../../Common/Network/API';
import Alert from '../../Common/Alert';
import $ from 'jquery';
import { Client_URL } from '../../Common/config';
import { useWebProperties } from '../../Common/webProperties';
import { getDecimalHours } from '../../Common/convertDecimalHoursToTime';
import { startOfWeek, endOfWeek } from 'date-fns';
import { DateRangePicker } from 'react-date-range';
import moment from 'moment';
import UserProjectInfo from '../../AdminModule/Reports/userProjectInfo';
import { getUserRanks } from './Services/getUserRanks';
import './ranks.css';
// import jwt_decode from "jwt-decode";
// import { isLoaded, isLoading } from '../../Common/Actions/loading';
// import { setCurrentUser } from '../../Common/Actions';
// import { setStatus, setToken, setRoleCount } from '../../Common/LocalStorage';
// import store from '../../Common/Store';
// import { Redirect } from 'react-router';

export default function UserProfile() {
    const [state, dispatch1] = useReducer(reducer, initialState);
    const getUser = useSelector(state => state.auth)

    // const [shifts, updateShifts] = useState([]);
    const [show, setShow] = useState(false);
    const [info, setInfo] = useState();
    const [open, setOpen] = useState({ status: false, index: 0 })
    const [calShow, setCalShow] = useState(false);
    const [license_key, setLicense] = useState('');
    const [displayName, setDisplayName] = useState();
    const [filter, setFilter] = useState([
        {
            startDate: startOfWeek(new Date(), { weekStartsOn: 0 }),
            endDate: endOfWeek(new Date(), { weekEndsOn: 7 }),
            key: 'selection'
        }
    ])
    const dispatch = useDispatch();
    const { KUDOS_TITLE, SUBTASK, THANKS_REASON, DATE_OF_AWARD, AWARD_BY, THANKS_DESCRIPTION, THANKS_POINTS_SUMMARY,
        THANKS_POINTS, SQUAD_MEMBER_ID, USERNAME, FULLNAME,
        EMAIL, MOBILE, WORKING_HOURS, ROLE, PROFILE, ACCOUNT_STATUS, VERIFIED_ACCOUNT, VERIFY, EMPLOYEE_EFFICIENCY_REPORT, ASSIGNED_STORY_POINTS, COMPLETED, DATE, NO_OF_PROJECTS_INVOLVED, PENDING, SELECT_DATE_RANGE, TOTAL_HOURS, TOTAL_USER_STORIES, USER_EFFICIENCY_HOURS, USER_EFFICIENCY_STORY_POINTS, role_array, DISPLAY_NAME } = useWebProperties();
    const properties = useSelector(state => state.landingReducer.properties)
    useEffect(() => {
        let dateFilter = [{
            "startDate": moment(filter[0].startDate).format("YYYY-MM-DD"),
            "endDate": moment(filter[0].endDate).format("YYYY-MM-DD"),
            "key": "selection"
        }]
        getProfile(dispatch1, getUser.user);
        getUserThanksPoints(dispatch1, getUser.user);
        getUserReports(dispatch1, getUser.user, dateFilter)
        getUserRanks(dispatch1, getUser.user, dateFilter)
        // getShifts()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (state.awards.length > 0) {
            $(document).ready(function () {
                window.$('#example').DataTable({
                    destroy: true,
                    retrieve: true,
                    fixedHeader: true,
                })
            })
        }
        //  eslint-disable-next-line 
    }, [state.awards])

    useEffect(() => {
        if (state.ranks.length > 0) {
            $(document).ready(function () {
                window.$('#ranks').DataTable({
                    destroy: true,
                    retrieve: true,
                    fixedHeader: true,
                })
            })
        }
        //  eslint-disable-next-line 
    }, [state.ranks])

    const handleClose = () => {
        setShow(false)
        getProfile(dispatch1, getUser.user)
        setCalShow(false)
    };
    const handleShow = () => setShow(true);//for upgrade
    const handleModalClose = () => {
        setOpen({ status: false, index: 0 });
        setShow(false);
    }
    const handleCalShow = () => setCalShow(true);//for upgrade
    // const getShifts = async () => {
    //     try {
    //         const response = await API.post("get_user_shifts.php", { action: "get_shifts" }, {}, false);
    //         var shift_times = [];
    //         if (response.status === 'True') {
    //             response.data.map((shift) => {
    //                 return shift_times.push({ value: shift.ts_id, label: shift.start_time + " - " + shift.end_time + " " + shift.time_zone })
    //             })
    //             updateShifts(shift_times)
    //         }
    //     } catch (error) {
    //     }
    // }
    const accountVerify = async () => {
        try {
            const response = await API.post("get_user.php",
                {
                    action: "account_verify",
                    url: Client_URL,
                    username: getUser.user.userName
                }, {}, false);
            if (response.status === 'True') {
                Alert('success', response.message);
            }
        } catch (error) {
            Alert('error', error.message);
        }
    }
    //project is archived start.
    // const handleArchiveOpen = () => setOpen(true);

    // const handleArchiveClose = () => setOpen(false);

    // const archiveProject = async () => {
    //     const project_id = getUser.user.projectId;
    //     try {
    //         var response = await API.post("squads.php", {
    //             action: "archive_project",
    //             project_id: project_id,
    //             is_active: 0,
    //         }, {}, false);
    //         if (response.status === 'True') {
    //             switchProject();
    //         } else {
    //             //switchProject();
    //         }
    //     } catch (error) {
    //         // Alert('error',error.message)
    //         setOpen(false);
    //     }
    // }

    //Switch to another project after project is archived.
    // const switchProject = async () => {
    //     store.dispatch(isLoading());
    //     try {
    //         const response = await API.post("sso_authentication.php", {
    //             username: getUser.user.userName,
    //             name: getUser.user.fullName,
    //             action: 'sso_sign_in'
    //         }, {
    //         });
    //         if (response.status === "TRUE") {
    //             setToken('auth', response.jwt) //store the token information  with exp
    //             const tokenDetails = jwt_decode(response.jwt);
    //             setRoleCount('roleCount', tokenDetails.data.roleCount)
    //             dispatch(setCurrentUser(tokenDetails.data)); //store the user information
    //             setStatus('status', tokenDetails.data.empStatus)
    //             setRedirect(true)
    //             store.dispatch(isLoaded());
    //         } else if (response.status === "False") {
    //             setRoleCount('roleCount', response.roleCount)
    //             setToken('empId', response.empId) //store the token information  with exp
    //             setToken('user', response.username) //store the token information  with exp
    //             setRedirect(true)
    //             store.dispatch(isLoaded());
    //         }
    //         else {
    //             store.dispatch(isLoaded());
    //             Alert('warning', response.message)
    //         }
    //     }
    //     catch (error) {
    //         Alert('error', error.message)
    //         store.dispatch(isLoaded());
    //     }
    // }

    // if (redirect) {
    //     return <Redirect to="/" />
    // }
    //project is archived end.

    const handleOpen = (index, action, task_status, column_name) => {
        setOpen({ status: true, index: index, action: action });
        var info = {};
        let dateFilter = [{
            "startDate": moment(filter[0].startDate).format("YYYY-MM-DD"),
            "endDate": moment(filter[0].endDate).format("YYYY-MM-DD"),
            "key": "selection"
        }]
        if (action === "getAllStories") {
            info = {
                user_id: getUser.user.empId,
                action: 'getAllStories',
                name: getUser.user.fullName,
                dateFilter,
                task_status,
                column_name
            }
        }
        if (action === "getOnlyStories") {
            info = {
                user_id: getUser.user.empId,
                action: 'getOnlyStories',
                name: getUser.user.fullName,
                dateFilter,
                task_status,
                column_name
            }
        }
        if (action === "getUtilizationStories") {
            info = {
                user_id: getUser.user.empId,
                action: 'getUtilizationStories',
                name: getUser.user.fullName,
                dateFilter,
                task_status,
                column_name
            }
        }
        if (action === "getUtilizationHours") {
            info = {
                user_id: getUser.user.empId,
                action: 'getUtilizationHours',
                name: getUser.user.fullName,
                dateFilter,
                task_status,
                column_name
            }
        }
        if (action === "getUserTimeSheets") {
            info = {
                user_id: getUser.user.empId,
                action: 'getUserTimeSheets',
                name: getUser.user.fullName,
                dateFilter,
                column_name,
                from: 'profile'
            }
        }
        if (action === "getUserProjects") {
            info = {
                user_id: getUser.user.empId,
                action: 'getUserProjects',
                name: getUser.user.fullName,
                dateFilter,
                column_name
            }
        }
        setInfo(info);
    };

    const getLatestReportData = () => {
        let dateFilter = [{
            "startDate": moment(filter[0].startDate).format("YYYY-MM-DD"),
            "endDate": moment(filter[0].endDate).format("YYYY-MM-DD"),
            "key": "selection"
        }]
        getUserReports(dispatch1, getUser.user, dateFilter)
        handleClose()
    }

    const saveDisplayImage = async () => {

        try {
            const response = await API.post("get_user.php",
                {
                    action: "save_display_name",
                    display_name: displayName,
                    empId: getUser.user.empId
                }, {}, false);
            if (response.status === 'True') {
                Alert('success', response.message);
                getProfile(dispatch1, getUser.user);
            }
        } catch (error) {
            Alert('error', error.message);
        }
    }

    const handleSearch = (dispatch1) => {
        getUserRanks(dispatch1, getUser.user, filter)
        getLatestReportData();
    }
   

    const child = document.getElementById('childElement');
    if (child) {
        child.remove();
    }

    return (
        <div className="container-scroller">

            <TopNav />
            <div className="container-fluid page-body-wrapper">
                <SideBar />
                <div className="main-panel">
                    <div className="mt-2">
                        <div className="col-md-12 grid-margin stretch-card">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <h4 className="card-title mb-2 ml-2">{PROFILE}</h4>
                                        {/* <div className=" col-md-12 d-flex justify-content-end" style={{ marginTop: '-40px' }}>
                                            {state.isLoading ? <RootLoader /> :
                                                <button type="submit" className="btn btn
                                            
                                            -success border mr-2"
                                                    onClick={(event) => { updateData(state, dispatch, getUser.user) }} style={{ borderRadius: '30px' }}>SAVE</button>}
                                        </div> */}
                                    </div>
                                    <hr></hr>
                                    {state.isLoading ? <RootLoader /> : <form className="forms-sample">
                                        <div className="form-group row" >
                                            <label className="col-sm-3 col-form-label">{SQUAD_MEMBER_ID}</label>
                                            <div className="col-sm-9">
                                                <label className="col-sm-6 col-form-label">{state.empId.value}</label>
                                            </div>
                                        </div>
                                        <div className="form-group row" >
                                            <label className="col-sm-3 col-form-label">{USERNAME}</label>
                                            <div className="col-sm-9">
                                                <label className="col-sm-6 col-form-label">{state.username.value}</label>
                                            </div>
                                        </div>
                                        <div className="form-group row" >
                                            <label className="col-sm-3 col-form-label">{FULLNAME}</label>
                                            <div className="col-sm-9">
                                                <label className="col-sm-6 col-form-label">{state.fullName.value}</label>
                                            </div>
                                        </div>
                                        <div className="form-group row" >
                                            <label className="col-sm-3 col-form-label">{DISPLAY_NAME}</label>
                                            {(state.display_name.value !== null && state.display_name.value !== '') ? (
                                                <div className="col-sm-9">
                                                <label className="col-sm-6 col-form-label">{state.display_name.value}</label>
                                                </div>
                                            ) : (
                                                <div className="col-sm-9 input-group">
                                                <input type="text" id="displayNameInput" className="form-control form-control-sm col-sm-4" style={{ borderWidth: '0.1px', width: '300px' }} aria-describedby="button-addon2" aria-label="username" value={displayName} onChange={(e) => {
                                                    if (/^[a-zA-Z0-9]*$/.test(e.target.value) || e.target.value === '') {
                                                        setDisplayName(e.target.value);
                                                        if (e.target.value.trim()) {
                                                            document.getElementById("displayNameInput").classList.remove("is-invalid");
                                                        }
                                                    }
                                                    }} placeholder="Enter name"/>
                                                <div className="input-group-append">
                                                    <button className="btn btn-outline-secondary" type="button" id="button-addon2" onClick={() => {
                                                        if (!displayName.trim()) {
                                                        document.getElementById("displayNameInput").classList.add("is-invalid"); return;}
                                                        document.getElementById("displayNameInput").classList.remove("is-invalid"); saveDisplayImage();}}>
                                                    <img src="images/common/arrow-forward.svg" style={{ width: '18px', height: '18px', cursor: 'pointer' }} alt="arrow-forward" />
                                                    </button>
                                                </div>
                                                <div className="invalid-feedback"> Please enter a valid display name.</div>
                                                </div>
                                            )}
                                            </div>
                                        <div className="form-group row" >
                                            <label className="col-sm-3 col-form-label">{EMAIL}</label>
                                            <div className="col-sm-9">
                                                <label className="col-sm-6 col-form-label">{state.email.value}</label>
                                            </div>
                                        </div>
                                        {/* <div className="form-group row" >
                                            <label className="col-sm-3 col-form-label">Designation</label>
                                            <div className="col-sm-9">
                                                <label className="col-sm-6 col-form-label">{state.designation.value}</label>
                                            </div>
                                        </div> */}
                                        {/* <div className="form-group row" >
                                            <label className="col-sm-3 col-form-label">Team</label>
                                            <div className="col-sm-9">
                                                <label className="col-sm-6 col-form-label">{state.team.value}</label>
                                            </div>
                                        </div> */}
                                        <div className="form-group row" >
                                            <label className="col-sm-3 col-form-label">{MOBILE}</label>
                                            <div className="col-sm-9">
                                                {/* <input type="text"
                                         className={ state.mobile.errorStatus ? "col-sm-3 col-form-label errorstyle" : "col-sm-3 col-form-label" }
                                         style={{borderRadius:'30px',borderBlockColor:'grey',borderWidth:'0.2px'}}
                                         placeholder="Enter Mobile number"
                                         value={state.mobile.value}
                                         onChange={(event) => dispatch(actions.updateMobileNumber(event.target.value))}
                                         required
                                         data-toggle="tooltip" data-placement="right" title="Enter a Valid Mobile Number For Communication"/>
                                        <small style={{ color: "red", fontSize: '12px' }}>{state.mobile.errorStatus ? state.mobile.errorMessage : ""}</small> */}
                                                <label className="col-sm-6 col-form-label">{state.mobile.value}</label>
                                            </div>
                                        </div>
                                        <div className="form-group row" >
                                            <label className="col-sm-3 col-form-label">{ROLE}</label>
                                            <div className="col-sm-9">
                                                <label className="col-sm-6 col-form-label">{role_array[state.role.value]}</label>
                                            </div>
                                        </div>

                                        <div className="form-group row" >
                                            <label className="col-sm-3 col-form-label" >{WORKING_HOURS}</label>
                                            <div className="col-sm-9">
                                                <label className="col-sm-6 col-form-label">{state.shift_hours.value}</label>
                                            </div>
                                            {/* <Select
                                                className="col-sm-3 col-form-label"
                                                style={{ width: 10, boarderRadius: 2 }}
                                                maxMenuHeight={150}
                                                placeholder={state.shift_hours.value}
                                                onChange={(selectedOption) =>
                                                    selectSprint(selectedOption)
                                                }
                                                options={shifts}
                                            /> */}
                                        </div>
                                        <div className="form-group row" >
                                            <label className="col-sm-3 col-form-label">{ACCOUNT_STATUS}</label>
                                            <div className="col-sm-9">
                                                {state.email_status.value === '1' ? <label className="col-sm-6 col-form-label text-success">{VERIFIED_ACCOUNT}</label> : <button className="btn-success" title="Verify your email for account verification" onClick={() => accountVerify()}>{VERIFY}</button>}
                                            </div>
                                        </div>
                                        <div className="form-group row" >
                                            <label className="col-sm-3 col-form-label">Account Type</label>
                                            <div className="col-sm-9">
                                                <label className="col-sm-6 col-form-label">{(state.license_validity.value === 'NA' || state.license_validity.value === 'FREE') ? 'FREE' : 'PAID'}</label>
                                            </div>
                                        </div>
                                        <div className="form-group row" >
                                            <label className="col-sm-3 col-form-label">Remaining Projects</label>
                                            <div className="col-sm-9">
                                                <label className="col-sm-6 col-form-label">{state.remaining_projects.value}</label>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <button type='button' className='btn-success ml-2' onClick={handleShow}> UPGRADE</button>
                                        </div>

                                        {/* <div className="form-group row" >
                                            <label className="col-sm-3 col-form-label">Functional Manager</label>
                                            <div className="col-sm-9">
                                                <label className="col-sm-6 col-form-label">{state.functionalManager.value}</label>
                                            </div>
                                        </div> */}
                                        {/* <div className="form-group row" >
                                            <label  className="col-sm-3 col-form-label">Status</label>
                                            <div className="col-sm-9">
                                                <label  className="col-sm-6 col-form-label">{state.status.value}</label>
                                            </div>
                                        </div> */}

                                    </form>}
                                    {/* Project Archive Individually
                                    {(getUser.user.role === SCRUM_MASTER || getUser.user.role === PRODUCT_OWNER) && (
                                        <>
                                        <label className="col-sm-3 col-form-label" style={{ fontSize: '1.1rem', fontWeight: 'bold', margin: '0rem -1.5rem' }}>{ARCHIVE_PROJECT} :</label><div style={{ display: 'flex', fontWeight: 'bold', flexDirection: 'column', margin: '1rem -1rem', border: '1px solid lightgray', padding: '1rem 0rem' }}>
                                            <div>
                                                <label className="col-sm-6 col-form-label">{AGILE_PROJECT_NAME} : {getUser.user.corp}</label>
                                                <button title="Once the project is archived you will no longer have access. Only admin can reopen the Archived Projects." data-toggle="modal" data-target="#exampleModal" className='btn-success' onClick={() => handleArchiveOpen()}>{ARCHIVE_PROJECT}</button>
                                            </div>
                                            <p style={{ padding: '0.6rem', color: 'red' }}>Note : Once the project is archived you will no longer have access. Only admin can reopen the Archived Projects.</p>
                                        </div>
                                        </>)} */}
                                    {state.awards.length > 0 ?
                                        <div className="table-responsive">
                                            <h4 className="card-title mb-2 text-success">{THANKS_POINTS_SUMMARY}</h4>
                                            <table
                                                search="true"
                                                id="example" className="table table-striped table-bordered rwd-table"
                                                style={{ width: '100%', overflow: 'auto' }}
                                                data-pagination="true"
                                            >
                                                <thead style={{ backgroundColor: '#F4FAF7' }}>
                                                    <tr>
                                                        <th>{KUDOS_TITLE}</th>
                                                        <th>{THANKS_REASON}</th>
                                                        <th>{THANKS_DESCRIPTION}</th>
                                                        <th>{THANKS_POINTS}</th>
                                                        <th>{AWARD_BY}</th>
                                                        <th>{DATE_OF_AWARD}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        state.awards.length > 0 ? state.awards.map((awards, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    {(awards.story_title === "" || awards.story_title === null) ? <td data-th={SUBTASK} style={{ textTransform: "capitalize" }}>General Award</td> : <td style={{ textTransform: "capitalize" }}>{awards.story_title}</td>}
                                                                    <td data-th={THANKS_REASON} style={{ textTransform: "capitalize" }}>{awards.kudo_description}</td>
                                                                    <td data-th={THANKS_DESCRIPTION} style={{ textTransform: "capitalize" }}>{awards.description}</td>
                                                                    <td data-th={THANKS_POINTS} style={{ textTransform: "capitalize" }}>{awards.kudos_award}</td>
                                                                    <td data-th={AWARD_BY} style={{ textTransform: "capitalize" }}>{awards.awardedby}</td>
                                                                    <td data-th={DATE_OF_AWARD} style={{ textTransform: "capitalize" }}>{awards.award_date}</td>
                                                                </tr>
                                                            )
                                                        }) : null}
                                                </tbody>
                                            </table>
                                        </div> : <div>
                                            {/* <h4 className="card-title mb-2 text-warning">No Kudos Point Summary</h4> */}
                                        </div>}

                                    <div className="col-12 " >
                                        <Modal style={{ textAlign: 'center' }} size="xl" show={calShow} onHide={handleClose}>
                                            <Modal.Header closeButton>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <DateRangePicker
                                                    onChange={item => setFilter([item.selection])}
                                                    showSelectionPreview={true}
                                                    moveRangeOnFirstSelection={false}
                                                    months={2}
                                                    ranges={filter}
                                                    direction="horizontal"
                                                />
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <button className="btn btn-success" type="button" onClick={() => {
                                                    handleSearch(dispatch1)
                                                }}>Search</button>
                                            </Modal.Footer>
                                        </Modal>

                                    </div>

                                    <div className="table-responsive arc">
                                        <div className='mt-2 mb-2' style={{ display: 'flex', alignItems: "center" }}>
                                            <div>
                                                <h4 className="card-title mb-2 text-success mt-2">{EMPLOYEE_EFFICIENCY_REPORT}</h4>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: "center", width: '80%', justifyContent: 'flex-end' }}>
                                                <button className="btn btn-success p-2 border" style={{ marginLeft: 10 }} onClick={handleCalShow}>{SELECT_DATE_RANGE}</button>

                                                <div style={{ marginTop: 5 }}>
                                                    <text style={{ fontSize: 14, fontWeight: 'bold', paddingLeft: 10 }} className=' text-success'> {DATE}: {(moment(filter[0].startDate).format('ll'))} - {(moment(filter[0].endDate).format('ll'))} </text>
                                                </div>
                                            </div>
                                        </div>
                                        {state.efficiency.length > 0 ?
                                            <table
                                                search="true"
                                                id="example" className="table table-striped table-bordered"
                                                data-pagination="true"
                                            >
                                                <thead style={{ backgroundColor: '#F4FAF7' }}>
                                                    <tr>
                                                        <th>{properties?.NO_OF_PROJECTS_INVOLVED || NO_OF_PROJECTS_INVOLVED}</th>
                                                        <th>{properties?.TOTAL_HOURS || TOTAL_HOURS}</th>
                                                        <th>{properties?.USER_EFFICIENCY_HOURS || USER_EFFICIENCY_HOURS}{" "}%</th>
                                                        <th>{properties?.USER_EFFICIENCY_STORY_POINTS || USER_EFFICIENCY_STORY_POINTS}{" "}%</th>
                                                        <th>{properties?.TOTAL_USER_STORIES || TOTAL_USER_STORIES}</th>
                                                        <th>{properties?.ASSIGNED_STORY_POINTS || ASSIGNED_STORY_POINTS}</th>
                                                        <th>{properties?.PENDING || PENDING}</th>
                                                        <th>{properties?.COMPLETED || COMPLETED}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        state.efficiency.length !== 0 ? state.efficiency?.map((x, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td onClick={() => handleOpen(index, "getUserProjects", "", properties?.NO_OF_PROJECTS_INVOLVED || NO_OF_PROJECTS_INVOLVED)}><p style={{ height: 40, fontWeight: 'bold', color: 'blue', cursor: 'pointer' }}>{x.projects_involved}</p></td>
                                                                    <td onClick={() => handleOpen(index, "getUserTimeSheets", "", properties?.TOTAL_HOURS || TOTAL_HOURS)}><p style={{ height: 40, fontWeight: 'bold', color: 'blue', cursor: 'pointer' }}>{x.working_hours !== null ? getDecimalHours(x.working_hours) : 0}</p></td>
                                                                    {x.utilization_based_on_hours !== null ? <td onClick={() => handleOpen(index, "getUtilizationHours", "all", properties?.USER_EFFICIENCY_HOURS || USER_EFFICIENCY_HOURS)}><p style={{ height: 40, fontWeight: 'bold', color: 'blue', cursor: 'pointer' }}>{x.utilization_based_on_hours}</p></td> : <td><p style={{ height: 40, fontWeight: 'bold', color: 'blue', cursor: 'pointer' }}>0</p></td>}
                                                                    {x.utilization_based_on_task !== null ? <td onClick={() => handleOpen(index, "getUtilizationStories", "all", properties?.USER_EFFICIENCY_STORY_POINTS || USER_EFFICIENCY_STORY_POINTS)}><p style={{ height: 40, fontWeight: 'bold', color: 'blue', cursor: 'pointer' }}>{x.utilization_based_on_task}</p></td> : <td><p style={{ height: 40, fontWeight: 'bold', color: 'blue', cursor: 'pointer' }}>0</p></td>}
                                                                    <td onClick={() => handleOpen(index, "getAllStories", "all", properties?.TOTAL_USER_STORIES || TOTAL_USER_STORIES)}><p style={{ height: 40, fontWeight: 'bold', color: 'blue', cursor: 'pointer' }}>{x.estimated !== null ? parseInt(x.estimated) : 0}</p></td>
                                                                    <td onClick={() => handleOpen(index, "getOnlyStories", "all", properties?.ASSIGNED_STORY_POINTS || ASSIGNED_STORY_POINTS)}><p style={{ height: 40, fontWeight: 'bold', color: 'blue', cursor: 'pointer' }}>{x.user_story_count !== null ? x.user_story_count : 0}</p></td>
                                                                    <td onClick={() => handleOpen(index, "getAllStories", "pending", properties?.PENDING || PENDING)}><p style={{ height: 40, fontWeight: 'bold', color: 'blue', cursor: 'pointer' }}>{x.pending !== null ? x.pending : 0}</p></td>
                                                                    <td onClick={() => handleOpen(index, "getAllStories", "completed", properties?.COMPLETED || COMPLETED)}><p style={{ height: 40, fontWeight: 'bold', color: 'blue', cursor: 'pointer' }}>{x.completed !== null ? x.completed : 0}</p></td>
                                                                </tr>
                                                            )
                                                        }) : null}
                                                </tbody>
                                            </table>
                                            :
                                            null
                                        }
                                        <div className="table-responsive mt-4">
                                            <h4 className="card-title mb-2 text-success">User Rankings</h4>
                                            {state.isLoadingRanks ? <RootLoader /> :
                                                <table
                                                    search="true"
                                                    id="ranks" className="table table-striped table-bordered rwd-table tableUserRanks">
                                                    <thead style={{ backgroundColor: '#F4FAF7' }}>
                                                        <tr>
                                                            <th>Award On</th>
                                                            <th title='Does the person understand from others communication and vice versa'>Communication</th>
                                                            <th title='Capability to eliminate roadblocks for others and ensure availability to assist in removing their barriers'>Leadership</th>
                                                            <th title='Demonstrating teamwork and being available when needed to support the team and achieve their goals'>team</th>
                                                            <th title='Takes personal responsibility for tasks, actively works towards achieving organizational goals, and feels accountable for any failures'>Ownership</th>
                                                            <th title='Delivers within committed timelines, especially when it matters most, and understands the criticality to deliver what is needed'>Execution</th>
                                                            <th>Percentage(%)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {state.ranks.length > 0 ? state.ranks?.map((rank, i) => (
                                                            <tr key={rank.r_id} style={{ height: '10px' }}>
                                                                <td>{(moment(rank.start_date).format('ll'))} - {(moment(rank.end_date).format('ll'))}</td>
                                                                <td>{rank.communication}</td>
                                                                <td>{rank.leadership}</td>
                                                                <td>{rank.team}</td>
                                                                <td>{rank.ownership}</td>
                                                                <td>{rank.execution}</td>
                                                                <td>{rank.percentage} %</td>
                                                            </tr>
                                                        )) :  null}
                                                    </tbody>
                                                </table>
                                            }
                                        </div>
                                    </div>
                                </div>
                                {
                                    (open.action === "getUserTimeSheets" || open.action === "getAllStories" || open.action === "getOnlyStories" || open.action === "getUtilizationStories" || open.action === "getUtilizationHours" || open.action === "getUserProjects") ? <UserProjectInfo open={open.status} data={info} handleClose={handleClose} handleModalClose={handleModalClose}
                                    /> : null
                                }

                            </div>

                            <div className="col-12 " >
                                <Modal style={{ textAlign: 'center' }} size="lg" show={show} onHide={handleModalClose}>
                                    <Modal.Header style={{ backgroundColor: '#D2ECDF', margin: 0 }} >
                                        <Modal.Title> <h6 class="modal-title" style={{ paddingTop: 8, paddingLeft: 5 }}>Upgrade Account</h6></Modal.Title>
                                        <button style={{ backgroundColor: 'transparent', border: '0' }} type="button" onClick={handleClose} className="d-flex align-items-right" data-dismiss="modal"><i class="mdi mdi-close text-black"></i></button>
                                    </Modal.Header>
                                    <Modal.Body style={{ height: 120, width: 400 }}>
                                        <input type='text' placeholder='license key' className='form-control mt-3' value={license_key} onChange={(e) => { setLicense(e.target.value) }} />
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <button className="btn-outline-success text-left" style={{ borderRadius: '20px' }} onClick={() => { updateAccountType(state, dispatch, getUser.user, license_key, handleClose) }}>
                                            upgrade
                                        </button>
                                        {/* {state.free_licenses.value ==='0'? <p >Your account has free license,<b style={{color:'blue',cursor:'pointer'}} onClick={()=>{generateLicense(state, dispatch, getUser.user,handleClose,handleModalClose)}}>Click here</b> to generate license key</p>:<p>Buy license key to upgrade your account</p>} */}
                                    </Modal.Footer>
                                </Modal>
                            </div>

                            {/* Project Archive Individually
                              <div className="col-12 " >
                                <Modal style={{ textAlign: 'center' }} size="lg" show={open} onHide={() => handleArchiveClose()}>
                                    <Modal.Header style={{ backgroundColor: '#D2ECDF', margin: 0 }} >
                                        <Modal.Title> <h6 class="modal-title" style={{ paddingTop: 8, paddingLeft: 2, fontWeight: '600' }}>Are you sure you want to {ARCHIVE_PROJECT} ?</h6></Modal.Title>
                                        <button style={{ backgroundColor: 'transparent', border: '0' }} type="button" onClick={() => handleArchiveClose()} className="d-flex align-items-right" data-dismiss="modal"><i class="mdi mdi-close text-black"></i></button>
                                    </Modal.Header>
                                    <Modal.Body style={{ height: 90, width: 320 }}>
                                        <label className='mt-3' style={{ display: 'flex', justifyContent: 'flex-start' }}>{AGILE_PROJECT_NAME}: {getUser.user.corp} </label>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <button className="btn-outline-success text-right" style={{ borderRadius: '20px' }} onClick={() => archiveProject()}>
                                            {ARCHIVE_PROJECT}
                                        </button>
                                        <button className="btn-outline-fail text-left" style={{ borderRadius: '20px' }} onClick={() => handleArchiveClose()}>
                                            Close
                                        </button>
                                    </Modal.Footer>
                                </Modal>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}